import { render, staticRenderFns } from "./ShowContactComponent.vue?vue&type=template&id=4e2483bc"
import script from "./ShowContactComponent.vue?vue&type=script&lang=js"
export * from "./ShowContactComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports